import { combineReducers } from "@reduxjs/toolkit";
import arUniEntryRequestFilter from "./arUniEntryRequestFilter";
import arUniEntryRequests from "./arUniEntryRequests";

const requestReducers = combineReducers({
  arUniEntryRequestFilter: arUniEntryRequestFilter,
  arUniEntryRequests: arUniEntryRequests,
});

export default requestReducers;
